import React from 'react';
import { getMessage } from '@tcc/i18n';
import styles from './ApplicationCard.css';

export interface ApplicationCardProps {
  active?: boolean;
  url: string;
  name: string;
  formattedDate: string;
  onClick: () => void;
  testId?: string;
  id?: string;
}

const ApplicationCard = ({
  active, 
  url, 
  name, 
  formattedDate, 
  onClick, 
  testId 
}: ApplicationCardProps) => {
  const activeStyle = active ? styles.active : '';
  return (
    <div
      className={`${activeStyle} ${styles.application}`}
      data-test-id={testId}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <img alt={getMessage('image.application.card')} src={url} />
      <div className={styles.column}>
        <h2>{name}</h2>
        <time dateTime={formattedDate}>{formattedDate}</time>
      </div>
    </div>
  );
};

export default ApplicationCard;